import { setChatlistOpen, setChatlistOpenHover } from '../../Store/features/chatlist/chatlistSlice';
import { ListIcon, PushPinIcon, XIcon } from '@phosphor-icons/react';
import { RootState, useAppDispatch, useAppSelector } from '../../store';

export default function ChatListToggleButton() {
    const chatlistOpen = useAppSelector((state: RootState) => state.chatlist.chatlistOpen);
    const chatlistOpenHover = useAppSelector((state: RootState) => state.chatlist.chatlistOpenHover);
    const dispatch = useAppDispatch();
    return (
        <>
            <button
                onClick={() => {
                    dispatch(setChatlistOpen(!chatlistOpen));
                    localStorage.setItem('chatlistOpen', (!chatlistOpen).toString());
                }}
                onMouseEnter={() => dispatch(setChatlistOpenHover(true))}
                className={`hidden xl:flex fixed z-[99] left-6 top-6 h-[50px] w-[50px] rounded-full flex justify-center items-center transition-all duration-[300ms] cursor-pointer ${
                    chatlistOpen
                        ? 'bg-chatlist-hoverButton-background-active text-chatlist-hoverButton-text-active'
                        : 'bg-chatlist-hoverButton-background text-chatlist-hoverButton-text hover:bg-chatlist-hoverButton-background-hover'
                }`}
            >
                {chatlistOpenHover && !chatlistOpen ? (
                    <PushPinIcon size={24} />
                ) : chatlistOpen ? (
                    <XIcon size={24} />
                ) : (
                    <ListIcon size={24} />
                )}
            </button>
        </>
    );
}
